import { MvnCodeFE } from "@maven-msg/lang/const";
import { MvnCodeInitiate } from "@maven-msg/lib/const";

export const IDENTITY_VERIFICATION_LANG: {
  IDENTITY_VERIFICATION_ERROR_MESSAGE: MvnCodeFE;
  IDENTITY_VERIFICATION_MULTIPLE_FAILED: MvnCodeFE;
  IDENTITY_VERIFICATION_CODE_SEND_ALREADY: MvnCodeFE;
  IDENTITY_VERIFICATION_CODE_REQUIRED: MvnCodeFE;
  IDENTITY_VERIFICATION_BIRTH_YEAR_REQUIRED: MvnCodeFE;
  IDENTITY_VERIFICATION_SMS_CODE_REQUIRED: MvnCodeFE;
} = {
  IDENTITY_VERIFICATION_ERROR_MESSAGE: {
    ko: "인증 정보를 확인한 뒤 다시 시도해 주세요.",
    en: "Please check the authentication information and try again.",
  },
  IDENTITY_VERIFICATION_MULTIPLE_FAILED: {
    ko: "여러 번 실패하여 현재 인증을 진행할 수 없습니다. 잠시 후 다시 시도해 주세요.",
    en: "Authentication cannot continue because there were multiple failed attempts. Please try again later.",
  },
  IDENTITY_VERIFICATION_CODE_SEND_ALREADY: {
    ko: "최근 발송된 인증번호를 확인해 주세요. 반복된 인증 실패로 인증이 제한된 경우 잠시 후 다시 시도해 주세요.",
    en: "Please check the authentication code that was recently sent. If authentication is temporarily restricted due to repeated failed attempts, please try again later.",
    fr: "Veuillez vérifier le code d’authentification envoyé récemment. Si l’authentification est temporairement limitée en raison de plusieurs tentatives infructueuses, veuillez réessayer plus tard.",
    nl: "Controleer de onlangs verzonden authenticatiecode. Als de authenticatie tijdelijk is beperkt vanwege meerdere mislukte pogingen, probeer het dan later opnieuw.",
  },
  IDENTITY_VERIFICATION_CODE_REQUIRED: {
    ko: "인증 코드를 입력해 주세요.",
    en: "Please enter the authentication code.",
  },
  IDENTITY_VERIFICATION_BIRTH_YEAR_REQUIRED: {
    ko: "생년을 입력해 주세요.",
    en: "Please enter your year of birth.",
  },
  IDENTITY_VERIFICATION_SMS_CODE_REQUIRED: {
    ko: "SMS 인증 코드를 입력해 주세요.",
    en: "Please enter the SMS authentication code.",
  },
};

MvnCodeInitiate(IDENTITY_VERIFICATION_LANG);
